import { useState } from "react";
import {
  AlertDialog, AlertDialogTrigger, AlertDialogContent, AlertDialogHeader, AlertDialogFooter,
  AlertDialogTitle, AlertDialogDescription, AlertDialogAction, AlertDialogCancel,
} from "@/components/ui/alert-dialog";
import { Input } from "@/components/ui/input";

// Strong confirmation for deleting a signed order: the admin must type the order number.
export const ConfirmDeleteSigned = ({ number, onConfirm, testid, children }) => {
  const [typed, setTyped] = useState("");
  const ok = typed.trim() === number;
  return (
    <AlertDialog onOpenChange={(o) => !o && setTyped("")}>
      <AlertDialogTrigger asChild>{children}</AlertDialogTrigger>
      <AlertDialogContent data-testid={`${testid}-dialog`}>
        <AlertDialogHeader>
          <AlertDialogTitle className="text-destructive">Supprimer une commande signée ?</AlertDialogTitle>
          <AlertDialogDescription>
            La commande <strong>{number}</strong> a été signée par le client. Elle sera placée dans la corbeille des devis pendant 30 jours, puis effacée définitivement avec la preuve de la commande.
            <br />Pour confirmer, saisissez le numéro de la commande :
          </AlertDialogDescription>
        </AlertDialogHeader>
        <Input value={typed} onChange={(e) => setTyped(e.target.value)} placeholder={number} data-testid={`${testid}-input`} />
        <AlertDialogFooter>
          <AlertDialogCancel data-testid={`${testid}-cancel`}>Annuler</AlertDialogCancel>
          <AlertDialogAction disabled={!ok} onClick={() => onConfirm(typed.trim())} className="bg-destructive text-destructive-foreground hover:bg-destructive/90" data-testid={`${testid}-confirm`}>
            Mettre à la corbeille
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
};
